export const uiSchema = t => {
  return {
    "ui:order": ["manager_instructions", "overdue_rtw_instructions", "*"],
    managerInstructions: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 4,
      },
    },
    overdueRtwInstructions: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 4,
      },
    },
    attachAbsenceReport: {
      "ui:widget": "hidden",
    },
  };
};
